(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('simpleProductSelector', simpleProductSelector);

    function simpleProductSelector(CommonHelper, $timeout, lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: "=",
            },
            link: function (scope, elem, attr, ctrl) {
                scope.sps = {};

                ctrl.render = function () {
                    if (CommonHelper.isEmpty(ctrl.$viewValue)) {
                        scope.sps.selected_id = null;
                    } else {
                        scope.sps.selected_id = ctrl.$viewValue;
                    }
                };

                scope.sps.selectProduct = selectProduct;
                scope.sps.products = scope.options.products;
                $timeout(function() {

                    if (!scope.sps.selected_id) {
                        var first_enabled_product = lodash.find(scope.sps.products, {enabled: 1});
                        if (first_enabled_product) {
                            selectProduct(first_enabled_product);
                        }
                    }
                });
                // scope.sps.products = [
                //     {
                //         'id': 1,
                //         'name': 'RP Parser',
                //         'price': {
                //             'value': 'Free',
                //         }
                //     },
                //     {
                //         'id': 2,
                //         'name': 'Sovren',
                //         'price': {
                //             'value': '$5',
                //             'unit': 'per request'
                //         }
                //     },
                // ];

                function selectProduct(product) {
                    scope.sps.selected_id = product.id;
                    ctrl.$setViewValue(scope.sps.selected_id);
                }

            },
            templateUrl: 'common/app/components/product-selector/simple-product-selector',
        };
    }
})();